module.exports = __webpack_public_path__ + "img/gnu_smart_gallery9.141c2952.jpg";